import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../../services/api/api.service';
import { SessionService } from '../../services/session/session.service';

@Injectable({
  providedIn: 'root'
})
export class ExactSuperadminGuard implements CanActivate {
  constructor(
    private apiService: ApiService,
    private sessionService: SessionService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.apiService.isAuthenticated()) {
      this.sessionService.loginUrl = state.url;
      void this.router.navigate(['/login']);
      return false;
    }
    if (!this.sessionService.isExactSuperAdmin()) {
      void this.router.navigate(['/finance/contracts']);
      return false;
    }
    return true;
  }
}
